import actionTypes from './actionTypes';

const INITIAL_STATE = {
  reservationPrintData: [],
  reservationInvoiceDetailsLoading: false,
  reservationInvoiceDetailsFailed: false,
  reservationInvoiceDetailsError: false,
  reservationInvoiceDetailsMessage: null,
  reservationInvoiceDetails: {},
  reservationInvoiceStatus: '',

  reservationTemporaryReceiptLoading: false,
  reservationTemporaryReceiptFailed: false,
  reservationTemporaryReceiptError: false,
  reservationTemporaryReceiptMessage: null,
  reservationTemporaryReceipt: [],

  reservationFactorPrintLoading: false,
  reservationFactorPrintFailed: false,
  reservationFactorPrintError: false,
  reservationFactorPrintMessage: null,
  reservationFactorPrint: {},

  reservationRequestsLoading: false,
  reservationRequestsFailed: false,
  reservationRequestsError: false,
  reservationRequestsMessage: null,
  reservationRequestsList: [],
  reservationRequestsListTotalRecords: 0,

  incomingReservationsLoading: false,
  incomingReservationsFailed: false,
  incomingReservationsError: false,
  incomingReservationsMessage: null,
  incomingReservationsTotalRecords: 0,
  incomingReservationsList: [],

  editCafeReservationStatusLoading: false,
  editCafeReservationStatusFailed: false,
  editCafeReservationStatusError: false,
  editCafeReservationStatusMessage: null,

  cafeReservationDetailsLoading: false,
  cafeReservationDetailsFailed: false,
  cafeReservationDetailsError: false,
  cafeReservationDetailsMessage: null,
  cafeReservationDetails: {},

  // TODO
  tableNumbersLoading: false,
  tableNumbersFailed: false,
  tableNumbersError: false,
  tableNumbersMessage: null,
  tableNumbers: {},
  tableNumbersList: [],

  startReservationLoading: false,
  startReservationFailed: false,
  startReservationError: false,
  startReservationMessage: null,

  cafeReservationsLoading: false,
  cafeReservationsFailed: false,
  cafeReservationsError: false,
  cafeReservationsMessage: null,
  cafeReservationsList: [],
  cafeReservations: {},

  userReservationsLoading: false,
  userReservationsFailed: false,
  userReservationsError: false,
  userReservationsMessage: null,
  userReservationsList: [],
  userReservations: {},

  checkoutOrClientAbsentReservesLoading: false,
  checkoutOrClientAbsentReservesFailed: false,
  checkoutOrClientAbsentReservesError: false,
  checkoutOrClientAbsentReservesMessage: null,
  checkoutOrClientAbsentReservesList: [],
  checkoutOrClientAbsentReserves: {},

  clientAbsentOrNotFinishedReservesLoading: false,
  clientAbsentOrNotFinishedReservesFailed: false,
  clientAbsentOrNotFinishedReservesError: false,
  clientAbsentOrNotFinishedReservesMessage: null,
  clientAbsentOrNotFinishedReservesList: [],
  clientAbsentOrNotFinishedReserves: {},

  checkoutCafeReservesLoading: false,
  checkoutCafeReservesFailed: false,
  checkoutCafeReservesError: false,
  checkoutCafeReservesMessage: null,

  checkoutDetailsLoading: false,
  checkoutDetailsFailed: false,
  checkoutDetailsError: false,
  checkoutDetailsMessage: null,
  checkoutDetails: {},

  finalCheckoutLoading: false,
  finalCheckoutFailed: false,
  finalCheckoutError: false,
  finalCheckoutMessage: null,

  incomingSchematicReservationsLoading: false,
  incomingSchematicReservationsFailed: false,
  incomingSchematicReservationsError: false,
  incomingSchematicReservationsMessage: null,
  incomingSchematicReservationsTotalRecords: 0,
  incomingSchematicReservationsList: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.FETCH_RESERVATION_INVOICE_DETAILS_LOADING:
      return {
        ...state,
        reservationInvoiceDetailsLoading: true,
        reservationInvoiceDetailsFailed: false,
        reservationInvoiceDetailsError: false,
        reservationInvoiceDetailsMessage: null,
        reservationInvoiceDetails: {},
        startReservationFailed: false,
        startReservationError: false,
        startReservationMessage: '',
        // temporarySaveInoviceItemsLoading: false,
        // temporarySaveInoviceItemsFailed: false,
        // temporarySaveInoviceItemsError: false,
        // temporarySaveInoviceItemsMessage: null,

        // finalSaveInoviceItemsLoading: false,
        // finalSaveInoviceItemsFailed: false,
        // finalSaveInoviceItemsError: false,
        // finalSaveInoviceItemsMessage: null
      };

    case actionTypes.FETCH_RESERVATION_INVOICE_DETAILS_SUCCESS:
      return {
        ...state,
        reservationInvoiceDetailsLoading: false,
        reservationInvoiceDetailsFailed: false,
        reservationInvoiceDetailsError: false,
        reservationInvoiceDetailsMessage: null,
        reservationInvoiceDetails: { ...action.payload },
        startReservationFailed: false,
        startReservationError: false,
        startReservationMessage: '',
        reservationInvoiceStatus: action.payload.reserveStatus,


        // temporarySaveInoviceItemsLoading: false,
        // temporarySaveInoviceItemsFailed: false,
        // temporarySaveInoviceItemsError: false,
        // temporarySaveInoviceItemsMessage: null,

        // finalSaveInoviceItemsLoading: false,
        // finalSaveInoviceItemsFailed: false,
        // finalSaveInoviceItemsError: false,
        // finalSaveInoviceItemsMessage: null
      };
    case actionTypes.FETCH_RESERVATION_INVOICE_DETAILS_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        reservationInvoiceDetailsLoading: false,
        reservationInvoiceDetailsFailed: true,
        reservationInvoiceDetailsError: false,
        reservationInvoiceDetailsMessage: message,
        reservationInvoiceDetails: {},

        startReservationFailed: false,
        startReservationError: false,
        startReservationMessage: '',

        // temporarySaveInoviceItemsLoading: false,
        // temporarySaveInoviceItemsFailed: false,
        // temporarySaveInoviceItemsError: false,
        // temporarySaveInoviceItemsMessage: null,

        // finalSaveInoviceItemsLoading: false,
        // finalSaveInoviceItemsFailed: false,
        // finalSaveInoviceItemsError: false,
        // finalSaveInoviceItemsMessage: null
      };
    }
    case actionTypes.FETCH_RESERVATION_INVOICE_DETAILS_REJECT:
      return {
        ...state,
        reservationInvoiceDetailsLoading: false,
        reservationInvoiceDetailsFailed: false,
        reservationInvoiceDetailsError: true,
        reservationInvoiceDetailsMessage: null,
        reservationInvoiceDetails: {},
        startReservationFailed: false,
        startReservationError: false,
        startReservationMessage: '',

        // temporarySaveInoviceItemsLoading: false,
        // temporarySaveInoviceItemsFailed: false,
        // temporarySaveInoviceItemsError: false,
        // temporarySaveInoviceItemsMessage: null,

        // finalSaveInoviceItemsLoading: false,
        // finalSaveInoviceItemsFailed: false,
        // finalSaveInoviceItemsError: false,
        // finalSaveInoviceItemsMessage: null
      };

    case actionTypes.FETCH_RESERVATION_TEMPORARY_PRINT_LOADING:
      return {
        ...state,
        reservationTemporaryReceiptLoading: true,
        reservationTemporaryReceiptFailed: false,
        reservationTemporaryReceiptError: false,
        reservationTemporaryReceiptMessage: null,
        reservationTemporaryReceipt: [],
      };

    case actionTypes.FETCH_RESERVATION_TEMPORARY_PRINT_SUCCESS:
      return {
        ...state,
        reservationTemporaryReceiptLoading: false,
        reservationTemporaryReceiptFailed: false,
        reservationTemporaryReceiptError: false,
        reservationTemporaryReceiptMessage: null,
        reservationTemporaryReceipt: action.payload,
      };
    case actionTypes.FETCH_RESERVATION_TEMPORARY_PRINT_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        reservationTemporaryReceiptLoading: false,
        reservationTemporaryReceiptFailed: true,
        reservationTemporaryReceiptError: false,
        reservationTemporaryReceiptMessage: message,
        reservationTemporaryReceipt: [],
      };
    }
    case actionTypes.FETCH_RESERVATION_TEMPORARY_PRINT_REJECT:
      return {
        ...state,
        reservationTemporaryReceiptLoading: false,
        reservationTemporaryReceiptFailed: false,
        reservationTemporaryReceiptError: true,
        reservationTemporaryReceiptMessage: null,
        reservationTemporaryReceipt: [],
      };

    case actionTypes.FETCH_RESERVATION_FACTOR_PRINT_LOADING:
      return {
        ...state,
        reservationFactorPrintLoading: true,
        reservationFactorPrintFailed: false,
        reservationFactorPrintError: false,
        reservationFactorPrintMessage: null,
        reservationFactorPrint: {},
      };

    case actionTypes.FETCH_RESERVATION_FACTOR_PRINT_SUCCESS:
      return {
        ...state,
        reservationFactorPrintLoading: false,
        reservationFactorPrintFailed: false,
        reservationFactorPrintError: false,
        reservationFactorPrintMessage: null,
        reservationFactorPrint: { ...action.payload },
      };
    case actionTypes.FETCH_RESERVATION_FACTOR_PRINT_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        reservationFactorPrintLoading: false,
        reservationFactorPrintFailed: true,
        reservationFactorPrintError: false,
        reservationFactorPrintMessage: message,
        reservationFactorPrint: {},
      };
    }
    case actionTypes.FETCH_RESERVATION_FACTOR_PRINT_REJECT:
      return {
        ...state,
        reservationFactorPrintLoading: false,
        reservationFactorPrintFailed: false,
        reservationFactorPrintError: true,
        reservationFactorPrintMessage: null,
        reservationFactorPrint: {},
      };
    case actionTypes.FETCH_RESERVATION_REQUESTS_LOADING:
      return {
        ...state,
        fetchReservationRequestsLoading: true,
        fetchReservationRequestsFailed: false,
        fetchReservationRequestsError: false,
        fetchReservationRequestsMessage: null,
        reservationRequestsList: [],
        reservationRequestsListTotalRecords: 0,

        cafeReservationDetailsLoading: true,
        cafeReservationDetailsFailed: false,
        cafeReservationDetailsError: false,
        cafeReservationDetailsMessage: null,
        cafeReservationDetails: {},
      };

    case actionTypes.FETCH_RESERVATION_REQUESTS_SUCCESS:
      return {
        ...state,
        fetchReservationRequestsLoading: false,
        fetchReservationRequestsFailed: false,
        fetchReservationRequestsError: false,
        fetchReservationRequestsMessage: null,
        reservationRequestsList: [...action.payload.reserves],
        reservationRequestsListTotalRecords: action.payload.totalRecords,

        cafeReservationDetailsLoading: false,
        cafeReservationDetailsFailed: false,
        cafeReservationDetailsError: false,
        cafeReservationDetailsMessage: null,
        cafeReservationDetails: {},
      };
    case actionTypes.FETCH_RESERVATION_REQUESTS_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        fetchReservationRequestsLoading: false,
        fetchReservationRequestsFailed: true,
        fetchReservationRequestsError: false,
        fetchReservationRequestsMessage: message,
        reservationRequestsList: [],
        reservationRequestsListTotalRecords: 0,

        cafeReservationDetailsLoading: false,
        cafeReservationDetailsFailed: true,
        cafeReservationDetailsError: false,
        cafeReservationDetailsMessage: null,
        cafeReservationDetails: {},
      };
    }

    case actionTypes.FETCH_RESERVATION_REQUESTS_REJECT:
      return {
        ...state,
        fetchReservationRequestsLoading: false,
        fetchReservationRequestsFailed: false,
        fetchReservationRequestsError: true,
        fetchReservationRequestsMessage: null,
        reservationRequestsList: [],
        reservationRequestsListTotalRecords: 0,

        cafeReservationDetailsLoading: false,
        cafeReservationDetailsFailed: true,
        cafeReservationDetailsError: false,
        cafeReservationDetailsMessage: null,
        cafeReservationDetails: {},
      };

    case actionTypes.FETCH_INCOMING_RESERVATIONS_LOADING:
      return {
        ...state,
        incomingReservationsLoading: true,
        incomingReservationsFailed: false,
        incomingReservationsError: false,
        incomingReservationsMessage: null,
        incomingReservationsTotalRecords: 0,
        incomingReservationsList: [],

        cafeReservationDetailsLoading: true,
        cafeReservationDetailsFailed: false,
        cafeReservationDetailsError: false,
        cafeReservationDetailsMessage: null,
        cafeReservationDetails: {},
      };

    case actionTypes.FETCH_RESERVATION_PRINT_DATA_SUCCESS:
      return {
        ...state,
        reservationPrintData: action.payload,
      };

    case actionTypes.FETCH_INCOMING_RESERVATIONS_SUCCESS:
      return {
        ...state,
        incomingReservationsLoading: false,
        incomingReservationsFailed: false,
        incomingReservationsError: false,
        incomingReservationsMessage: null,
        incomingReservationsTotalRecords: action.payload.totalRecords,
        incomingReservationsList: [...action.payload.reserves],

        cafeReservationDetailsLoading: false,
        cafeReservationDetailsFailed: false,
        cafeReservationDetailsError: false,
        cafeReservationDetailsMessage: null,
        cafeReservationDetails: {},
      };
    case actionTypes.FETCH_INCOMING_RESERVATIONS_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        incomingReservationsLoading: false,
        incomingReservationsFailed: true,
        incomingReservationsError: false,
        incomingReservationsMessage: message,
        incomingReservationsTotalRecords: 0,
        incomingReservationsList: [],

        cafeReservationDetailsLoading: false,
        cafeReservationDetailsFailed: true,
        cafeReservationDetailsError: false,
        cafeReservationDetailsMessage: null,
        cafeReservationDetails: {},
      };
    }

    case actionTypes.FETCH_INCOMING_RESERVATIONS_REJECT:
      return {
        ...state,
        incomingReservationsLoading: false,
        incomingReservationsFailed: false,
        incomingReservationsError: true,
        incomingReservationsMessage: null,
        incomingReservationsTotalRecords: 0,
        incomingReservationsList: [],

        cafeReservationDetailsLoading: false,
        cafeReservationDetailsFailed: true,
        cafeReservationDetailsError: false,
        cafeReservationDetailsMessage: null,
        cafeReservationDetails: {},
      };

    case actionTypes.FETCH_TABLE_NUMBERS_LOADING:
      return {
        ...state,
        tableNumbersLoading: true,
        tableNumbersFailed: false,
        tableNumbersError: false,
        tableNumbersMessage: null,
        tableNumbers: {},
        tableNumbersList: [],
      };

    case actionTypes.FETCH_TABLE_NUMBERS_SUCCESS:
      return {
        ...state,
        tableNumbersLoading: false,
        tableNumbersFailed: false,
        tableNumbersError: false,
        tableNumbersMessage: null,
        tableNumbers: { ...action.payload },
        tableNumbersList: [...action.payload.tables],
      };
    case actionTypes.FETCH_TABLE_NUMBERS_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        tableNumbersLoading: false,
        tableNumbersFailed: true,
        tableNumbersError: false,
        tableNumbersMessage: message,
        tableNumbers: {},
        tableNumbersList: [],
      };
    }
    case actionTypes.FETCH_TABLE_NUMBERS_REJECT: {
      return {
        ...state,
        tableNumbersLoading: false,
        tableNumbersFailed: false,
        tableNumbersError: true,
        tableNumbersMessage: 'Server Error',
        tableNumbers: {},
        tableNumbersList: [],
      };
    }

    case actionTypes.START_RESERVATION_LOADING:
      return {
        ...state,
        startReservationLoading: true,
        startReservationFailed: false,
        startReservationError: false,
        startReservationMessage: null,

        cafeReservationDetailsLoading: true,
        cafeReservationDetailsFailed: false,
        cafeReservationDetailsError: false,
        cafeReservationDetailsMessage: null,
        cafeReservationDetails: {},
      };

    case actionTypes.START_RESERVATION_SUCCESS:
      return {
        ...state,
        startReservationLoading: false,
        startReservationFailed: false,
        startReservationError: false,
        startReservationMessage: null,

        cafeReservationDetailsLoading: false,
        cafeReservationDetailsFailed: false,
        cafeReservationDetailsError: false,
        cafeReservationDetailsMessage: null,
        cafeReservationDetails: {},
      };
    case actionTypes.START_RESERVATION_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        startReservationLoading: false,
        startReservationFailed: true,
        startReservationError: false,
        startReservationMessage: message,

        cafeReservationDetailsLoading: false,
        cafeReservationDetailsFailed: true,
        cafeReservationDetailsError: false,
        cafeReservationDetailsMessage: null,
        cafeReservationDetails: {},
      };
    }
    case actionTypes.START_RESERVATION_ERROR:
      debugger;
      return {
        ...state,
        startReservationLoading: false,
        startReservationFailed: false,
        startReservationError: true,
        startReservationMessage: null,

        cafeReservationDetailsLoading: false,
        cafeReservationDetailsFailed: true,
        cafeReservationDetailsError: false,
        cafeReservationDetailsMessage: null,
        cafeReservationDetails: {},
      };

    case actionTypes.FETCH_ALL_CAFE_RESERVATIONS_LOADING:
      return {
        ...state,
        cafeReservationsLoading: true,
        cafeReservationsFailed: false,
        cafeReservationsError: false,
        cafeReservationsMessage: null,

        cafeReservationDetailsLoading: true,
        cafeReservationDetailsFailed: false,
        cafeReservationDetailsError: false,
        cafeReservationDetailsMessage: null,
        cafeReservationDetails: {},
      };

    case actionTypes.FETCH_ALL_CAFE_RESERVATIONS_SUCCESS:
      return {
        ...state,
        cafeReservationsLoading: false,
        cafeReservationsFailed: false,
        cafeReservationsError: false,
        cafeReservationsMessage: null,
        cafeReservationsList: [...action.payload.reserves],
        cafeReservations: { ...action.payload },

        cafeReservationDetailsLoading: false,
        cafeReservationDetailsFailed: false,
        cafeReservationDetailsError: false,
        cafeReservationDetailsMessage: null,
        cafeReservationDetails: {},
      };
    case actionTypes.FETCH_ALL_CAFE_RESERVATIONS_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        cafeReservationsLoading: false,
        cafeReservationsFailed: true,
        cafeReservationsError: false,
        cafeReservationsMessage: message,

        cafeReservationDetailsLoading: false,
        cafeReservationDetailsFailed: true,
        cafeReservationDetailsError: false,
        cafeReservationDetailsMessage: null,
        cafeReservationDetails: {},
      };
    }
    case actionTypes.FETCH_ALL_CAFE_RESERVATIONS_ERROR: {
      return {
        ...state,
        cafeReservationsLoading: false,
        cafeReservationsFailed: false,
        cafeReservationsError: true,
        cafeReservationsMessage: null,

        cafeReservationDetailsLoading: false,
        cafeReservationDetailsFailed: false,
        cafeReservationDetailsError: true,
        cafeReservationDetailsMessage: null,
        cafeReservationDetails: {},
      };
    }

    case actionTypes.FETCH_CAFE_RESERVATION_DETAILS_LOADING:
      return {
        ...state,
        cafeReservationDetailsLoading: true,
        cafeReservationDetailsFailed: false,
        cafeReservationDetailsError: false,
        cafeReservationDetailsMessage: null,
        cafeReservationDetails: {},
        startReservationFailed: false,
        startReservationError: false,
        startReservationMessage: '',
        editCafeReservationStatusLoading: false,
        editCafeReservationStatusFailed: false,
        editCafeReservationStatusError: false,
        editCafeReservationStatusMessage: '',
      };

    case actionTypes.FETCH_CAFE_RESERVATION_DETAILS_SUCCESS:
      return {
        ...state,
        cafeReservationDetailsLoading: false,
        cafeReservationDetailsFailed: false,
        cafeReservationDetailsError: false,
        cafeReservationDetailsMessage: null,
        cafeReservationDetails: { ...action.payload },
        startReservationFailed: false,
        startReservationError: false,
        startReservationMessage: '',
        editCafeReservationStatusLoading: false,
        editCafeReservationStatusFailed: false,
        editCafeReservationStatusError: false,
        editCafeReservationStatusMessage: '',
      };
    case actionTypes.FETCH_CAFE_RESERVATION_DETAILS_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        cafeReservationDetailsLoading: false,
        cafeReservationDetailsFailed: true,
        cafeReservationDetailsError: false,
        cafeReservationDetailsMessage: message,
        cafeReservationDetails: {},
        startReservationFailed: false,
        startReservationError: false,
        startReservationMessage: '',
      };
    }
    case actionTypes.FETCH_CAFE_RESERVATION_DETAILS_ERROR: {
      return {
        ...state,
        cafeReservationDetailsLoading: false,
        cafeReservationDetailsFailed: false,
        cafeReservationDetailsError: true,
        cafeReservationDetailsMessage: null,
        cafeReservationDetails: {},
      };
    }

    case actionTypes.EDIT_CAFE_RESERVATION_STATUS_LOADING:
      return {
        ...state,
        editCafeReservationStatusLoading: true,
        editCafeReservationStatusFailed: false,
        editCafeReservationStatusError: false,
        editCafeReservationStatusMessage: null,

        cafeReservationDetailsLoading: true,
        cafeReservationDetailsFailed: false,
        cafeReservationDetailsError: false,
        cafeReservationDetailsMessage: null,
        cafeReservationDetails: {},
      };

    case actionTypes.EDIT_CAFE_RESERVATION_STATUS_SUCCESS:
      return {
        ...state,
        editCafeReservationStatusLoading: false,
        editCafeReservationStatusFailed: false,
        editCafeReservationStatusError: false,
        editCafeReservationStatusMessage: null,

        cafeReservationDetailsLoading: false,
        cafeReservationDetailsFailed: false,
        cafeReservationDetailsError: false,
        cafeReservationDetailsMessage: null,
        cafeReservationDetails: {},
      };
    case actionTypes.EDIT_CAFE_RESERVATION_STATUS_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        editCafeReservationStatusLoading: false,
        editCafeReservationStatusFailed: true,
        editCafeReservationStatusError: false,
        editCafeReservationStatusMessage: message,

        cafeReservationDetailsLoading: false,
        cafeReservationDetailsFailed: true,
        cafeReservationDetailsError: false,
        cafeReservationDetailsMessage: null,
        cafeReservationDetails: {},
      };
    }
    case actionTypes.EDIT_CAFE_RESERVATION_STATUS_ERROR: {
      return {
        ...state,
        editCafeReservationStatusLoading: false,
        editCafeReservationStatusFailed: false,
        editCafeReservationStatusError: true,
        editCafeReservationStatusMessage: null,

        cafeReservationDetailsLoading: false,
        cafeReservationDetailsFailed: false,
        cafeReservationDetailsError: true,
        cafeReservationDetailsMessage: null,
        cafeReservationDetails: {},
      };
    }

    case actionTypes.USER_RESERVATIONS_LOADING: {
      return {
        ...state,
        userReservationsLoading: true,
        userReservationsFailed: false,
        userReservationsError: false,
        userReservationsMessage: '',
        userReservationsList: [],
        userReservations: {},

        cafeReservationDetailsLoading: true,
        cafeReservationDetailsFailed: false,
        cafeReservationDetailsError: false,
        cafeReservationDetailsMessage: null,
        cafeReservationDetails: {},
      };
    }
    case actionTypes.USER_RESERVATIONS_SUCCESS: {
      return {
        ...state,
        userReservationsLoading: false,
        userReservationsFailed: false,
        userReservationsError: false,
        userReservationsMessage: '',
        userReservationsList: [...action.payload.reserves],
        userReservations: { ...action.payload },

        cafeReservationDetailsLoading: false,
        cafeReservationDetailsFailed: false,
        cafeReservationDetailsError: false,
        cafeReservationDetailsMessage: null,
        cafeReservationDetails: {},
      };
    }
    case actionTypes.USER_RESERVATIONS_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        userReservationsLoading: false,
        userReservationsFailed: true,
        userReservationsError: false,
        userReservationsMessage: message,
        userReservationsList: [],
        userReservations: {},

        cafeReservationDetailsLoading: false,
        cafeReservationDetailsFailed: true,
        cafeReservationDetailsError: false,
        cafeReservationDetailsMessage: null,
        cafeReservationDetails: {},
      };
    }
    case actionTypes.USER_RESERVATIONS_REJECT: {
      return {
        ...state,
        userReservationsLoading: false,
        userReservationsFailed: false,
        userReservationsError: true,
        userReservationsMessage: '',
        userReservationsList: [],
        userReservations: {},

        cafeReservationDetailsLoading: false,
        cafeReservationDetailsFailed: true,
        cafeReservationDetailsError: false,
        cafeReservationDetailsMessage: null,
        cafeReservationDetails: {},
      };
    }

    case actionTypes.FETCH_ALL_CHECKEDOUT_OR_CLIENT_ABSENT_RESERVES_LOADING: {
      return {
        ...state,
        checkoutOrClientAbsentReservesLoading: true,
        checkoutOrClientAbsentReservesFailed: false,
        checkoutOrClientAbsentReservesError: false,
        checkoutOrClientAbsentReservesMessage: '',
        checkoutOrClientAbsentReservesList: [],
        checkoutOrClientAbsentReserves: {},
      };
    }
    case actionTypes.FETCH_ALL_CHECKEDOUT_OR_CLIENT_ABSENT_RESERVES_SUCCESS: {
      return {
        ...state,
        checkoutOrClientAbsentReservesLoading: false,
        checkoutOrClientAbsentReservesFailed: false,
        checkoutOrClientAbsentReservesError: false,
        checkoutOrClientAbsentReservesMessage: '',
        checkoutOrClientAbsentReservesList: [
          ...action.payload.checkoutWithCafes,
        ],
        checkoutOrClientAbsentReserves: { ...action.payload },
      };
    }
    case actionTypes.FETCH_ALL_CHECKEDOUT_OR_CLIENT_ABSENT_RESERVES_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        checkoutOrClientAbsentReservesLoading: false,
        checkoutOrClientAbsentReservesFailed: true,
        checkoutOrClientAbsentReservesError: false,
        checkoutOrClientAbsentReservesMessage: message,
        checkoutOrClientAbsentReservesList: [],
        checkoutOrClientAbsentReserves: {},
      };
    }
    case actionTypes.FETCH_ALL_CHECKEDOUT_OR_CLIENT_ABSENT_RESERVES_REJECT: {
      return {
        ...state,
        checkoutOrClientAbsentReservesLoading: false,
        checkoutOrClientAbsentReservesFailed: false,
        checkoutOrClientAbsentReservesError: true,
        checkoutOrClientAbsentReservesMessage: '',
        checkoutOrClientAbsentReservesList: [],
        checkoutOrClientAbsentReserves: {},
      };
    }

    case actionTypes.FETCH_ALL_CLIENT_ABSENT_OR_NOT_FINISHED_RESERVES_LOADING: {
      return {
        ...state,
        clientAbsentOrNotFinishedReservesLoading: true,
        clientAbsentOrNotFinishedReservesFailed: false,
        clientAbsentOrNotFinishedReservesError: false,
        clientAbsentOrNotFinishedReservesMessage: '',
        clientAbsentOrNotFinishedReservesList: [],
        clientAbsentOrNotFinishedReserves: {},
      };
    }
    case actionTypes.FETCH_ALL_CLIENT_ABSENT_OR_NOT_FINISHED_RESERVES_SUCCESS: {
      return {
        ...state,
        clientAbsentOrNotFinishedReservesLoading: false,
        clientAbsentOrNotFinishedReservesFailed: false,
        clientAbsentOrNotFinishedReservesError: false,
        clientAbsentOrNotFinishedReservesMessage: '',
        clientAbsentOrNotFinishedReservesList: [...action.payload.reserves],
        clientAbsentOrNotFinishedReserves: { ...action.payload },
      };
    }
    case actionTypes.FETCH_ALL_CLIENT_ABSENT_OR_NOT_FINISHED_RESERVES_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        clientAbsentOrNotFinishedReservesLoading: false,
        clientAbsentOrNotFinishedReservesFailed: true,
        clientAbsentOrNotFinishedReservesError: false,
        clientAbsentOrNotFinishedReservesMessage: message,
        clientAbsentOrNotFinishedReservesList: [],
        clientAbsentOrNotFinishedReserves: {},
      };
    }
    case actionTypes.FETCH_ALL_CLIENT_ABSENT_OR_NOT_FINISHED_RESERVES_REJECT: {
      return {
        ...state,
        clientAbsentOrNotFinishedReservesLoading: false,
        clientAbsentOrNotFinishedReservesFailed: false,
        clientAbsentOrNotFinishedReservesError: true,
        clientAbsentOrNotFinishedReservesMessage: '',
        clientAbsentOrNotFinishedReservesList: [],
        clientAbsentOrNotFinishedReserves: {},
      };
    }

    case actionTypes.CHECKOUT_CAFE_RESERVES_LOADING: {
      return {
        ...state,
        checkoutCafeReservesLoading: true,
        checkoutCafeReservesFailed: false,
        checkoutCafeReservesError: false,
        checkoutCafeReservesMessage: '',
      };
    }
    case actionTypes.CHECKOUT_CAFE_RESERVES_SUCCESS: {
      return {
        ...state,
        checkoutCafeReservesLoading: false,
        checkoutCafeReservesFailed: false,
        checkoutCafeReservesError: false,
        checkoutCafeReservesMessage: '',
      };
    }
    case actionTypes.CHECKOUT_CAFE_RESERVES_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        checkoutCafeReservesLoading: false,
        checkoutCafeReservesFailed: true,
        checkoutCafeReservesError: false,
        checkoutCafeReservesMessage: message,
      };
    }
    case actionTypes.CHECKOUT_CAFE_RESERVES_REJECT: {
      return {
        ...state,
        checkoutCafeReservesLoading: false,
        checkoutCafeReservesFailed: false,
        checkoutCafeReservesError: true,
        checkoutCafeReservesMessage: '',
      };
    }

    case actionTypes.FETCH_CHECKOUT_DETAILS_LOADING: {
      return {
        ...state,
        checkoutDetailsLoading: true,
        checkoutDetailsFailed: false,
        checkoutDetailsError: false,
        checkoutDetailsMessage: '',
        checkoutDetails: {},
      };
    }
    case actionTypes.FETCH_CHECKOUT_DETAILS_SUCCESS: {
      return {
        ...state,
        checkoutDetailsLoading: false,
        checkoutDetailsFailed: false,
        checkoutDetailsError: false,
        checkoutDetails: { ...action.payload },
        checkoutDetailsMessage: '',
      };
    }
    case actionTypes.FETCH_CHECKOUT_DETAILS_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        checkoutDetailsLoading: false,
        checkoutDetailsFailed: true,
        checkoutDetailsError: false,
        checkoutDetailsMessage: message,
        checkoutDetails: {},
      };
    }
    case actionTypes.FETCH_CHECKOUT_DETAILS_REJECT: {
      return {
        ...state,
        checkoutDetailsLoading: false,
        checkoutDetailsFailed: false,
        checkoutDetailsError: true,
        checkoutDetailsMessage: '',
        checkoutDetails: {},
      };
    }

    case actionTypes.FETCH_INCOMING_SCHEMATIC_RESERVATION_LOADING:
      return {
        ...state,
        incomingSchematicReservationsLoading: true,
        incomingSchematicReservationsFailed: false,
        incomingSchematicReservationsError: false,
        incomingSchematicReservationsMessage: null,
        incomingSchematicReservationsTotalRecords: 0,
        incomingSchematicReservationsList: [],
      };

    case actionTypes.FETCH_INCOMING_SCHEMATIC_RESERVATION_SUCCESS:
      return {
        ...state,
        incomingSchematicReservationsLoading: false,
        incomingSchematicReservationsFailed: false,
        incomingSchematicReservationsError: false,
        incomingSchematicReservationsMessage: null,
        incomingSchematicReservationsTotalRecords: action.payload.totalRecords,
        incomingSchematicReservationsList: [...action.payload],
      };
    case actionTypes.FETCH_INCOMING_SCHEMATIC_RESERVATION_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        incomingSchematicReservationsLoading: false,
        incomingSchematicReservationsFailed: true,
        incomingSchematicReservationsError: false,
        incomingSchematicReservationsMessage: message,
        incomingSchematicReservationsTotalRecords: 0,
        incomingSchematicReservationsList: [],
      };
    }

    case actionTypes.FETCH_INCOMING_SCHEMATIC_RESERVATION_REJECT:
      return {
        ...state,
        incomingSchematicReservationsLoading: false,
        incomingSchematicReservationsFailed: false,
        incomingSchematicReservationsError: true,
        incomingSchematicReservationsMessage: null,
        incomingSchematicReservationsTotalRecords: 0,
        incomingSchematicReservationsList: [],
      };

    default:
      return state;
  }
};
